import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from '../global/global.component';
import { SeoService } from '../service/seo.service';
import { Router } from '@angular/router';

@Component({
  selector: 'login-forvendor',
  templateUrl: './forvendor.component.html',
  styleUrls: ['./forvendor.component.scss']
})
export class ForvendorComponent implements OnInit {

  hostName = GlobalComponent.hostName;

  constructor(private SEOService:SeoService, private router :Router) { }

  ngOnInit(){
    window.scroll(0,0);

  this.SEOService.updateCanonicalUrl(this.hostName + '/vendorsbenefits');


  }

  signup()
    {
      this.router.navigate(['/login/signup']);

    }

}
